function getUserLoginStatus() {
    let userIdentity;
    if (CookieService) {
        userIdentity = CookieService.getCookie('userIdentity'); //registeredCustomer,existingCustomer, newCustomer 
        if (!userIdentity) {
            CookieService.setCookie('userIdentity', 'newCustomer', 365, '/', true);
        }
    }
  
    const userDetails = JSON.parse(sessionStorage.getItem('GatewayCustomer') || '{}');
    // Prefetching Customer details for R3 and R4
    const firstName = (userDetails?.name?.firstName ?? "").trim();
    const lastName = (userDetails?.name?.lastName ?? "").trim();
    const middleName = (userDetails?.name?.middleName ?? "").trim();
    const email = (userDetails?.email ?? "").trim();

    let userDetailsObj = {
        sender_firstName: firstName,
        sender_lastName: lastName,
        sender_middleName: middleName,
        sender_emailAddress: email
    }

    let isUserLogin = (userDetailsObj.sender_firstName && userDetailsObj.sender_lastName && userDetailsObj.sender_emailAddress) ? true : false;
    let hasFirstandLastname = (!userDetailsObj.sender_firstName && !userDetailsObj.sender_lastName && userDetailsObj.sender_emailAddress) ? true : false;

    if (hasFirstandLastname) {
        isUserLogin = true;
        sessionStorage.setItem('FirstName', 'Hello');
        sessionStorage.setItem('LastName', 'User');
    }

    // CAPELLA-441
    if ((userIdentity === 'registeredCustomer') || (userIdentity === 'existingCustomer')) {
        isUserLogin = true;
    }
    return isUserLogin;

}